import { render } from "./Yas.vue?vue&type=template&id=b004f6a6"
import script from "./Yas.vue?vue&type=script&lang=js"
export * from "./Yas.vue?vue&type=script&lang=js"

import "./Yas.vue?vue&type=style&index=0&id=b004f6a6&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__